import { Vault } from 'state/types'
import fetchPublicVaultData from './fetchPublicVaultData'

const fetchVault = async (vault: Vault): Promise<Vault> => {
  const vaultPublicData = await fetchPublicVaultData(vault)

  return { ...vault, ...vaultPublicData }
}

export default fetchVault
